/* import __COLOCATED_TEMPLATE__ from './clinician-step.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class RequestStepsClinicianStep extends Component {}
